export default "__VITE_ASSET__BKo$bKDY__"